import type { Channel } from '../types'
import Badge from './ui/Badge'
import { ChannelAvatar } from './ChannelAvatar'

interface Props {
  channel: Channel
  onClick: () => void
}

export default function ChannelCard({ channel, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      className="text-left rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] hover:border-[var(--color-border-strong)] p-4 group"
    >
      <div className="flex items-center justify-between mb-3 gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <ChannelAvatar channel={channel} size={32} />
          <div className="font-medium text-[var(--color-text)] group-hover:text-[var(--color-accent-hover)] truncate">
            {channel.slug}
          </div>
        </div>
        <Badge tone={channel.is_owner ? 'accent' : 'neutral'}>
          {channel.role}
        </Badge>
      </div>
      <div className="flex items-center gap-3 text-xs text-[var(--color-text-muted)]">
        <span className="flex items-center gap-1.5">
          <span
            className={[
              'w-1.5 h-1.5 rounded-full',
              channel.bot_enabled ? 'bg-[var(--color-success)]' : 'bg-[var(--color-text-subtle)]',
            ].join(' ')}
          />
          Bot {channel.bot_enabled ? 'aktif' : 'pasif'}
        </span>
        {channel.bot_reply && (
          <span className="text-[var(--color-text-subtle)]">· yanıt veriyor</span>
        )}
        {channel.link_tracking_enabled && (
          <span className="text-[var(--color-text-subtle)]">· link takibi</span>
        )}
      </div>
    </button>
  )
}
